import Badge from '@/components/ui/Badge';
import type { IntegrationStatus } from '@/hooks/useIntegrations';

const LABELS: Record<IntegrationStatus, { text: string; variant: 'green' | 'yellow' | 'red' | 'gray' }> = {
  connected: { text: 'Connected', variant: 'green' },
  connecting: { text: 'Connecting…', variant: 'yellow' },
  error: { text: 'Needs attention', variant: 'red' },
  disconnected: { text: 'Not connected', variant: 'gray' },
};

export default function StatusBadge({ status }: { status: IntegrationStatus }) {
  const { text, variant } = LABELS[status] ?? LABELS.disconnected;
  return <Badge variant={variant}>{text}</Badge>;
}
